import { AbstractControl, ValidationErrors } from '@angular/forms';

function isEmptyInputValue(value: any): boolean {
  // we don't check for string here so it also works with arrays
  return !value || value.length === 0;
}

const DISSALLOWED_SYMBOLS = [
  '<',
  '>',
  '/',
  '\\',
  '{',
  '}',
  '[',
  ']',
  '(',
  ')',
  ';',
  ':',
  '"',
  '`',
  '~',
  '!',
  '@',
  '#',
  '$',
  '%',
  '^',
  '&',
  '*',
  '=',
  '+',
];

export class WizValidators {
  static noSymbols(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;
    }

    for (const symbol of DISSALLOWED_SYMBOLS) {
      if (control.value.includes(symbol)) {
        return { noSymbols: true };
      }
    }
    return null;
  }
}
